import React, { useEffect, useState, useContext } from "react";
import Container from "react-bootstrap/Container";
import { Nav, Modal, Button, Dropdown } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "../AxiosInstance";
import { useAuth } from "../context/auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { LanguageContext } from "../context/LanguageContext";
const Header = () => {
  const [show, setShow] = useState(false); // For signup modal
  const [showLogin, setShowLogin] = useState(false); // For login modal
  const [showEmail, setShowEmail] = useState(false); // For login modal
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibilityy = () => setShowPassword((prev) => !prev);

  // Handle closing both modals
  const handleClose = () => {
    setShow(false); // Close signup modal
    setShowLogin(false); // Close login modal
    setShowEmail(false);
  };

  // Handle opening signup modal
  const handleShow = () => {
    setShow(true); // Open signup modal
    setShowLogin(false); // Close login modal if open
    setShowEmail(false);
  };

  // Handle opening signup modal
  const handleShowEmail = () => {
    setShowEmail(true); // Open signup modal
    setShow(false);
    setShowLogin(false); // Close login modal if open
  };

  const handleEmailClose = () => {
    setShow(false); // Close signup modal
    setShowLogin(false); // Close login modal
    setShowEmail(false);
  };

  // Handle opening login modal
  const handleLoginShow = () => {
    setShow(false); // Close signup modal
    setShowEmail(false);
    setShowLogin(true); // Open login modal
  };

  // Handle closing login modal
  const handleLoginClose = () => {
    setShowLogin(false); // Close login modal
  };

  const navigate = useNavigate();

  const [fShow, setFShow] = useState(false); // For Forget Password modal
  const handleFClose = () => {
    setFShow(false); // Close signup modal
  };
  // Handle opening signup modal
  const handleFShow = () => {
    setFShow(true); // Open Forget Password  modal
    setShowLogin(false);
  };

  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const [passwordNewVisible, setPasswordNewVisible] = useState(false);

  const togglePasswordNewVisibility = () => {
    setPasswordNewVisible((prevState) => !prevState);
  };

  // ==============Language Change===========================
  const translations = {
    english: {
      changeLanguageText: "Change your language",
      // Add other English texts
    },
    deutsch: {
      changeLanguageText: "Ändern Sie Ihre Sprache",
      // Add other German texts
    },
    español: {
      changeLanguageText: "Cambia tu idioma",
      // Add other Spanish texts
    },
    francais: {
      changeLanguageText: "Changez votre langue",
      // Add other French texts
    },

    italiano: {
      changeLanguageText: "Changez votre langue",
      // Add other French texts
    },
    // Add other languages as needed
  };

  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext);
  const [lShow, setLShow] = useState(false); // For signup modal

  const handleLClose = () => {
    setLShow(false); // Close signup modal
  };

  const handleLShow = () => {
    setLShow(true); // Open signup modal
  };

  const handleLanguageChange = (e) => {
    const lang = e.target.id;
    setSelectedLanguage(lang);
    localStorage.setItem("language", lang);
    console.log("Language changed to:", lang);
  };

  // ============== Integration =====================

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  // form function
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isChecked) {
      toast.error(
        "Please agree to the terms and conditions before signing up."
      );
      return;
    }
    try {
      const res = await axios.post("/api/v1/auth/register", {
        name,
        email,
        password,
        language: selectedLanguage,
      });
      if (res && res.data.success) {
        toast.success(res.data && res.data.message);
        setEmail("");
        setName("");
        setPassword("");
        setIsChecked("");
        setShowEmail(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  const [auth, setAuth] = useAuth();

  // form function
  const handleSubmitLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/api/v1/auth/login", {
        email,
        password,
      });
      if (res && res.data.success) {
        toast.success(res.data && res.data.message);
        setEmail("");

        setPassword("");
        setIsChecked("");
        setAuth({
          ...auth,
          user: res.data.user,
          token: res.data.token,
        });
        localStorage.setItem("auth", JSON.stringify(res.data));
        setShowLogin(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  // ================Logout==================

  const handleLogout = () => {
    setAuth({
      ...auth,
      user: null,
      token: "",
    });
    localStorage.removeItem("auth");
    toast.success("Logout Successfully");

    // Navigate to homepage
    navigate("/");
  };

  // ============== Integration ===================== //

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        style={{ backgroundColor: "#34C3C9" }}
        className="py-0"
      // className="bg-body-tertiary"
      >
        <Container className="classsheder">
          <Navbar.Brand href="/" className="p-0">
            <img
              className=" w-sm-100 mlogowidth mt-lg-3 mt-1 mb-2"
              src={require("../components/image/ofelliologocr.png")}
              alt="logo"
              width="230"
              height="90"
            />
          </Navbar.Brand>
          {/* <Navbar.Brand href="/">
            

            <img
              className=" w-sm-100 mlogowidth mt-3 mb-2"
              src={require("../components/image/ofelliologo.png")}
              alt="logo"
            />
          </Navbar.Brand> */}
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            className="z-index-2 w-100 position-relative pb-lg-0 pb-4 text-center position-absolute topclass top-sm-0 "
            style={{
              background: "#34C3C9",

              marginTop: "10px",
              // marginLeft: "-12px",
            }}
          >
            <Nav
              style={{ gap: "10px", color: "#FFFFFF" }}
              className="ms-auto  "
            >
              {/* {auth?.user && (
                <Nav.Link
                  className="ftznav fw-bold"
                  href="/createmeetup"
                  style={{
                    color: "#FFFFFF",
                    lineHeight: "24.51px",
                    fontSize: "18px",
                  }}
                  // onClick={() => navigate("/createmeetup")}
                >
                  Create 1 : 1
                </Nav.Link>
              )} */}

              <Nav.Link
                className="ftznav fw-bold"
                href="/howitworks"
                style={{
                  color: "#FFFFFF",

                  lineHeight: "24.51px",
                  fontSize: "18px",
                }}
              >
                How it works
              </Nav.Link>
              {/* Ambassador link removed - all users are now ambassadors */}
              {/* <Nav.Link
                href="/ambassador"
                className="ftznav fw-bold"
                style={{
                  color: "#FFFFFF",

                  lineHeight: "24.51px",
                  fontSize: "18px",
                }}
              >
                Ambassador
              </Nav.Link> */}
              {/* <Nav.Link
                className="ftznav fw-bold"
                href="/booksandreviews"
                style={{
                  color: "#FFFFFF",

                  lineHeight: "24.51px",
                  fontSize: "18px",
                }}
              >
                Books & Reviews
              </Nav.Link> */}
              <Dropdown>
                <Dropdown.Toggle as="div">
                  <Nav.Link
                    // href="/booksandreviews"
                    className="ftznav fw-bold"
                    style={{
                      color: "#FFFFFF",

                      lineHeight: "24.51px",
                      fontSize: "18px",
                    }}
                  >
                    Books & Reviews
                  </Nav.Link>
                </Dropdown.Toggle>
                <div className="pualpicdrop booksdropm">
                  <Dropdown.Menu className="py-1  ">
                    <Dropdown.Item
                      className="fs-6  fw-normal text-dark"
                      style={{ lineHeight: "21.79px" }}
                      onClick={() => navigate("/booksandreviews")}
                    >
                      English
                    </Dropdown.Item>

                    <Dropdown.Item
                      className="fs-6  fw-normal text-dark"
                      style={{ lineHeight: "21.79px" }}
                      onClick={() => navigate("/booksandreviews")}
                    >
                      Dutch
                    </Dropdown.Item>

                    <Dropdown.Item
                      className="fs-6  fw-normal text-dark"
                      style={{ lineHeight: "21.79px" }}
                      onClick={() => navigate("/booksandreviews")}
                    >
                      French
                    </Dropdown.Item>

                    <Dropdown.Item
                      className="fs-6  fw-normal text-dark"
                      style={{ lineHeight: "21.79px" }}
                      onClick={() => navigate("/booksandreviews")}
                    >
                      German
                    </Dropdown.Item>

                    <Dropdown.Item
                      className="fs-6 fw-normal text-dark"
                      style={{ lineHeight: "21.79px" }}
                      onClick={() => navigate("/booksandreviews")}
                    >
                      Italian
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </div>
              </Dropdown>

              {!auth?.user ? (
                <>
                  <Nav.Link
                    className="ftznav fw-bold"
                    href="#"
                    style={{
                      color: "#FFFFFF",

                      lineHeight: "24.51px",
                      fontSize: "18px",
                    }}
                    onClick={handleShow} // Show login modal
                  >
                    Log in/Sign in
                  </Nav.Link>
                  <div className="mt-1 px-2  " style={{ cursor: "pointer" }}>
                    <img
                      className="  "
                      src={require("../components/image/interneticon.png")}
                      alt="logo"
                      width="32px"
                      onClick={handleLShow} // Trigger modal on click
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="mt-1 px-2  " style={{ cursor: "pointer" }}>
                    <img
                      className=" mt-2 "
                      src={require("../components/image/msgbox.png")}
                      alt="logo"
                      width="21.53px"
                      onClick={() => navigate("/chatChak")}
                    />
                  </div>

                  <div className="mt-1 px-2  " style={{ cursor: "pointer" }}>
                    <img
                      className=" mt-2 "
                      src={require("../components/image/notification.png")}
                      alt="logo"
                      width="21.53px"
                    />
                  </div>

                  <div className="px-2" style={{ cursor: "pointer" }}>
                    <Dropdown className="dropclnrt2">
                      <Dropdown.Toggle as="div">
                        <img
                          src={require("../components/image/paulsmith.png")}
                          alt="logo"
                          // onClick={() => navigate("/dashboard")}
                          style={{ display: "inline-block" }}
                        />
                      </Dropdown.Toggle>
                      <div className="pualpicdrop">
                        <Dropdown.Menu className="py-2 px-1 ">
                          <Dropdown.Item
                            className="fs-6 mt-1 fw-normal text-dark"
                            style={{ lineHeight: "21.79px" }}
                            onClick={() => navigate("/profile")}
                          >
                            Dashboard
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                        className="fs-6 mt-1 fw-normal text-dark"
                        style={{ lineHeight: "21.79px" }}
                        onClick={() => navigate("/howitworks")}
                      >
                        How it works
                      </Dropdown.Item> */}
                          <Dropdown.Item
                            className="fs-6 mt-1 fw-normal text-dark"
                            style={{ lineHeight: "21.79px" }}
                            onClick={() => navigate("/settings")}
                          >
                            Settings
                          </Dropdown.Item>
                          <Dropdown.Item
                            className="fs-6 mt-1 fw-normal text-dark"
                            style={{ lineHeight: "21.79px" }}
                            onClick={handleLogout} //logout handle
                          >
                            Logout
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </div>
                    </Dropdown>
                  </div>
                </>

                // <>
                //   <Nav.Link
                //     className="ftznav fw-bold"
                //     href="#"
                //     style={{
                //       color: "#FFFFFF",

                //       lineHeight: "24.51px",
                //       fontSize: "18px",
                //     }}
                //     onClick={handleLogout} // Show logout
                //   >
                //     Logout
                //   </Nav.Link>
                // </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Modal Component */}
      <Modal show={show} onHide={handleClose} centered className="custom-modal">
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtn "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          Create an Ofellio Account
        </Modal.Title>
        <Modal.Body className="modelbody">
          <div className="text-center">
            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal  mt-4 my-1 position-relative modelacc  btnhover"
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/google.png")}
                alt="Google"
              />
              Continue with Google
            </Button>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4 fw-normal my-1 position-relative  modelacc  btnhover"
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",

                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/facebook.png")}
                alt="Facebook"
              />{" "}
              Continue with Facebook
            </Button>
            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal my-1 position-relative modelacc   btnhover "
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/apple.png")}
                alt="Apple"
              />
              Continue with Apple
            </Button>

            <Button
              variant="light"
              className="w-100 my-1 rounded-4  fs-5 fw-normal position-relative modelacc    btnhover"
              style={{
                maxWidth: "405px",
                height: "56px",
                border: "1px solid #6D6D6D",

                color: "#000000",
                lineHeight: "27.24px",
              }}
              onClick={handleShowEmail}
            >
              <img
                className=" position-absolute lefttt"
                src={require("../components/image/email.png")}
                alt="Email"
              />
              Continue with Email
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-center w-100">
            <div className="mt-2 mb-3 fs-4 fw-bold modeltitle ">
              Already a member?
            </div>
            <Button
              className="fs-5 text-white loginbtnwidmodel border-0 fw-bold w-100 "
              style={{
                backgroundColor: "#34C3C9",
                lineHeight: "27.24px",
                color: "#000000",
                maxWidth: "231px",
                height: "44px",
              }}
              onClick={handleLoginShow} // Show login modal
            >
              Login
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Login Modal */}
      <Modal
        show={showLogin}
        onHide={handleLoginClose}
        centered
        className="custom-modal custom-modallogin"
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn"
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleLoginClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center fw-bold modeltitle mt-3"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
            color: "#000000",
          }}
        >
          Login
        </Modal.Title>
        <Modal.Body className="modelbody">
          <div className="text-center">
            <form className="textleft  margg" onSubmit={handleSubmitLogin}>
              <div className="mb-3">
                <label
                  htmlFor="email"
                  className="form-label fs-5 ftlink text-left"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  Email
                </label>
                <input
                  type="email"
                  className="form-control fw600 fs-5 ftzevtt rounded-4 placeholder-login"
                  id="email"
                  autoFocus
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "56px",

                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>
              <div className="mb-3">
                <div className="d-flex  justify-content-between">
                  <label
                    htmlFor="password"
                    className="form-label ftlink fs-5"
                    style={{
                      color: "#000000",
                      lineHeight: "27.24px",
                      fontWeight: "600",
                    }}
                  >
                    Password
                  </label>
                  <label
                    htmlFor="password"
                    className="form-label fontmobil fw-normal "
                    style={{
                      color: "#000000",
                      lineHeight: "24.51px",
                      fontSize: "18px",
                    }}
                    // onClick={() => navigate("/forgot-password")}
                    onClick={handleFShow}
                  >
                    Forgot Password?
                  </label>
                </div>
                <div className="relative">


                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control fs-5 fw600  ftzevtt rounded-4 placeholder-login"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{
                      border: "1px solid #6D6D6D",
                      maxWidth: "539px",
                      height: "56px",

                      lineHeight: "27.24px",
                      color: "#7B7B7B",
                    }}
                  />
                  <div
                    className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
                    onClick={togglePasswordVisibilityy}
                    style={{ position: "absolute", top: "50%", right: "10px", transform: "translateY(-50%)", cursor: "pointer" }}
                  >
                    {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
                  </div>
                </div></div>
              <div className="form-check">
                <input
                  className="form-check-input rounded-0 placeholder-login"
                  type="checkbox"
                  required
                  defaultValue
                  id="flexCheckDefault"
                  style={{ border: "1px solid #6D6D6D " }}
                />
                <label
                  className="form-check-label fs-6"
                  htmlFor="flexCheckDefault"
                  style={{
                    color: "#4C4C4C",
                    fontWeight: "600",
                    lineHeight: "21.79px",
                  }}
                >
                  Keep me signed in
                </label>
              </div>
              <div className="text-center mt-3">
                <Button
                  type="submit"
                  className="fs-5 text-white loginbtnwidmodel border-0 fw-bold w-100 "
                  style={{
                    backgroundColor: "#34C3C9",
                    lineHeight: "27.24px",
                    color: "#000000",
                    maxWidth: "231px",
                    height: "44px",
                  }}
                  onClick={handleLoginShow} // Show login modal
                >
                  Login
                </Button>
              </div>

              <div className="d-flex justify-content-center gap-2 mt-4">
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "255px",
                    border: "1.4px solid #969696",

                    height: "1.4px",
                  }}
                ></div>

                <div
                  className="ftzcopy   fs-6 text-center"
                  style={{
                    color: "#595959",

                    fontFamily: "Open Sans",
                    fontWeight: "600",
                    lineHeight: "21.79px",
                    marginTop: "-10px",
                  }}
                >
                  or
                </div>
                <div
                  className="border-1 w-100 "
                  style={{
                    maxWidth: "255px",
                    border: "1.4px solid #969696",

                    height: "1.4px",
                  }}
                ></div>
              </div>
            </form>

            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal mtlow mt-4 my-1 position-relative modelacclogin btnhover"
              style={{
                maxWidth: "539px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt lefttt22"
                src={require("../components/image/google.png")}
                alt="Google"
              />
              Continue with Google
            </Button>
            <Button
              variant="light"
              className="w-100 fs-5 rounded-4  fw-normal my-1 position-relative modelacclogin btnhover "
              style={{
                maxWidth: "539px",
                height: "56px",
                border: "1px solid #6D6D6D",
                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt lefttt22"
                src={require("../components/image/apple.png")}
                alt="Apple"
              />
              Continue with Apple
            </Button>
            <Button
              variant="light"
              className="w-100 fs-5 rounded-4 fw-normal my-1 position-relative modelacclogin btnhover"
              style={{
                maxWidth: "539px",
                height: "56px",
                border: "1px solid #6D6D6D",

                color: "#000000",
                lineHeight: "27.24px",
              }}
            >
              <img
                className=" position-absolute lefttt lefttt22"
                src={require("../components/image/facebook.png")}
                alt="Facebook"
              />
              Continue with Facebook
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {/* SignUp Email Modal */}

      <Modal
        show={showEmail}
        onHide={handleEmailClose}
        centered
        className="custom-modal custom-modalsign"
      >
        <Modal.Header className="border-0">
          <img
            className="border-0 closebtn"
            src={require("../components/image/close.png")}
            alt="close"
            onClick={handleEmailClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
            color: "#000000",
          }}
        >
          Signing up
        </Modal.Title>
        <Modal.Body className="modelbody">
          <div className="text-center">
            <form className="textleft margg" onSubmit={handleSubmit}>
              <div className="mb-3">
                <label
                  htmlFor="name"
                  className="form-label fs-5 ftlink text-left"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  Your Name or Username
                </label>
                <input
                  type="text"
                  className="form-control w-100 fs-5 ftzevtt fw600 rounded-0 placeholder-login"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "56px",

                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>

              <div className="mb-3">
                <label
                  htmlFor="email"
                  className="form-label fs-5 ftlink text-left"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  E-mail
                </label>
                <input
                  type="email"
                  className="form-control w-100 rounded-0 fs-5 ftzevtt fw600 placeholder-login"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "56px",

                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>

              <div className="mb-3">
                <label
                  htmlFor="password"
                  className="form-label fs-5 ftlink"
                  style={{
                    color: "#000000",
                    lineHeight: "27.24px",
                    fontWeight: "600",
                  }}
                >
                  Password
                </label>

                <input
                  type="password"
                  className="form-control w-100 rounded-0 px-4 fs-5 ftzevtt fw600 placeholder-login"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="At least 8 characters"
                  style={{
                    border: "1px solid #6D6D6D",
                    maxWidth: "539px",
                    height: "56px",

                    lineHeight: "27.24px",
                    color: "#7B7B7B",
                  }}
                />
              </div>

              <div className="form-check">
                <input
                  className="form-check-input rounded-0 placeholder-login"
                  type="checkbox"
                  required
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  // defaultValue
                  id="flexCheckDefaultsigup"
                  style={{ border: "1px solid #6D6D6D " }}
                />
                <label
                  className="form-check-label fs-6"
                  htmlFor="flexCheckDefaultsigup"
                  style={{
                    color: "#4C4C4C",
                    fontWeight: "600",
                    lineHeight: "21.79px",
                  }}
                >
                  By signing up, you agree to{" "}
                  <span
                    style={{ color: "#EF0707", cursor: "pointer" }}
                    onClick={() => navigate("/terms")}
                  >
                    Terms of use
                  </span>
                  ,
                  <span
                    style={{ color: "#E33629", cursor: "pointer" }}
                    onClick={() => navigate("/privacy")}
                  >
                    {" "}
                    Privacy Policy{" "}
                  </span>
                  and{" "}
                  <span
                    style={{ color: "#E33629", cursor: "pointer" }}
                    onClick={() => navigate("/cookies")}
                  >
                    {" "}
                    Cookie Policy
                  </span>
                </label>
              </div>
            </form>

            <div className="text-center mt-4">
              <Button
                className="fs-5 text-white loginbtnwidmodel border-0 fw-bold w-100 "
                type="submit"
                style={{
                  backgroundColor: "#34C3C9",
                  lineHeight: "27.24px",
                  color: "#000000",
                  maxWidth: "231px",
                  height: "44px",
                }}
                onClick={handleSubmit}
              >
                Sign up
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-center  mt-md-3 w-100">
            <div
              className="text-center fs-6  "
              style={{
                color: "#4C4C4C",
                fontWeight: "600",
                lineHeight: "21.79px",
              }}
            >
              Already have an account,{" "}
              <span
                className="cursor-pointer"
                style={{ cursor: "pointer" }}
                onClick={handleLoginShow}
              >
                Sign in
              </span>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Modal ForGetPassword Component */}
      <Modal
        show={fShow}
        onHide={handleFClose}
        centered
        className="custom-modal custom-modalhegit"
      >
        <Modal.Header className=" border-0 ">
          <img
            className=" border-0 closebtn "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleFClose}
          />
        </Modal.Header>
        <Modal.Title
          className="text-center ptmodelpass11 text-dark fw-bold mt-3 modeltitle"
          style={{
            fontSize: "32px",
            lineHeight: "43.58px",
          }}
        >
          Change your password
        </Modal.Title>
        <Modal.Body className="modelbody text-center">
          <form className="textleft margg mt-3">
            <div className="mb-3">
              <label
                htmlFor="cpassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                Current Password
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="cpassword"
                  style={{ border: "0.1px " }}
                />

                <img
                  className="m-3"
                  src={require("../pages/image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordVisibility}
                />
                {/* <i
                    className={`bi ${
                      passwordVisible ? "bi-eye" : "bi-eye-slash"
                    }`}
                  ></i> */}
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="npassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                New Password
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordNewVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="npassword"
                  style={{ border: "0.1px " }}
                />

                <img
                  className="m-3"
                  src={require("../pages/image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordNewVisibility}
                />
              </div>
            </div>

            <div className="mb-3">
              <label
                htmlFor="cnpassword"
                className="form-label fw600 fs-5 ftzevtt text-left"
              >
                Confirm New Password
              </label>

              <div
                className="d-flex w-100 rounded-4 fw600"
                style={{
                  border: "1px solid #6D6D6D",
                  maxWidth: "539px",
                  height: "56px",

                  color: "#7B7B7B",
                }}
              >
                <input
                  type={passwordNewVisible ? "text" : "password"}
                  className="form-control w-100 fs-5 outline-none ftzevtt rounded-4 placeholder-login"
                  id="cnpassword"
                  style={{ border: "0.1px " }}
                />

                <img
                  className="m-3"
                  src={require("../pages/image/eyepassw.png")}
                  width="24"
                  height="24"
                  onClick={togglePasswordNewVisibility}
                />
                {/* <i
                    className={`bi ${
                      passwordVisible ? "bi-eye" : "bi-eye-slash"
                    }`}
                  ></i> */}
              </div>
            </div>
          </form>
          <div className="mt-4 text-center">
            <button
              className="w-100  eventcrtwid fw600 fs-5 !text-white text-center rounded-1 border-0"
              style={{
                maxWidth: "167px",
                height: "44px",
                backgroundColor: "#34C3C9",
              }}
            >
              Submit
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/* LangUage Change IP */}

      <Modal
        show={lShow}
        onHide={handleLClose}
        centered
        className="custom-modalques  radiolanguagemodel "
      >
        <Modal.Header className=" border-0">
          <img
            className=" border-0 closebtnlang "
            src={require("../components/image/close.png")}
            alt="logo"
            onClick={handleLClose}
          />
        </Modal.Header>
        <Modal.Title className="text-center mt-4 ">
          <div
            className="fw-bold mt-2 text-center ftzinput"
            style={{ fontSize: "22px" }}
          >
            {/* {translations[selectedLanguage].changeLanguageText}{" "} */}
            Change your language
            {/* Use dynamic translation */}
          </div>
        </Modal.Title>

        <Modal.Body className="mx-auto    ">
          <div>
            <div
              className="radiolanguage d-flex justify-content-center justify-content-sm-start gap-4 mt-4 flex-wrap w-100"
              style={{ maxWidth: "300px" }}
            >
              {["english", "francais", "deutsch", "italiano", "español"].map(
                (lang) => (
                  <div className="form-check mx-3" key={lang}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="language"
                      id={lang}
                      checked={selectedLanguage === lang}
                      onChange={handleLanguageChange}
                    />
                    <label className="form-check-label" htmlFor={lang}>
                      {lang.charAt(0).toUpperCase() + lang.slice(1)}
                    </label>
                  </div>
                )
              )}
            </div>

            {/* 
            <div
              className="radiolanguage  d-flex justify-content-center justify-content-sm-start gap-4 mt-4 flex-wrap w-100"
              style={{ maxWidth: "300px" }}
            >
              <div className="form-check mx-3">
                <input
                  type="radio"
                  className="form-check-input"
                  name="language"
                  id="english"
                  defaultChecked
                />
                <label className="form-check-label " htmlFor="english">
                  English
                </label>
              </div>
              <div className="form-check mx-3">
                <input
                  type="radio"
                  className="form-check-input"
                  name="language"
                  id="japanese"
                />
                <label className="form-check-label" htmlFor="francais">
                  Francais
                </label>
              </div>
              <div className="form-check mx-3">
                <input
                  type="radio"
                  className="form-check-input"
                  name="language"
                  id="german"
                />
                <label className="form-check-label" htmlFor="deutsch">
                  Deutsch
                </label>
              </div>
              <div className="form-check mx-3">
                <input
                  type="radio"
                  className="form-check-input"
                  name="language"
                  id="urdu"
                />
                <label className="form-check-label" htmlFor="italiano">
                  Italiano
                </label>
              </div>
              <div className="form-check mx-3">
                <input
                  type="radio"
                  className="form-check-input"
                  name="language"
                  id="spanish"
                />
                <label className="form-check-label" htmlFor="espanol">
                  Espanol
                </label>
              </div>
            </div> */}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
